/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BarcodesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Look up an item by barcode
     * @returns any Barcode lookup result
     * @throws ApiError
     */
    public lookupItemByBarcode({
        barcode,
    }: {
        barcode: string,
    }): CancelablePromise<{
        item_id: string;
        item_name: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/barcodes/lookup/{barcode}',
            path: {
                'barcode': barcode,
            },
            errors: {
                401: `Authentication required`,
                404: `Barcode not found`,
            },
        });
    }
}
